import type { UIEvent } from 'react';
import { useState } from 'react';
import { useOverflowDetector } from 'react-detectable-overflow';

const SCROLL_STEP = 300;
export const useScrollableBar = () => {
	const { ref, overflow } = useOverflowDetector({});
	const [scrollPosition, setScrollPosition] = useState<
		'left' | 'right' | 'center'
	>('left');

	const onLeftArrowClick = () => {
		if (!ref.current) {
			return;
		}
		const positionX: number = ref.current.scrollLeft;
		const scrollToX =
			positionX < SCROLL_STEP + 50 ? 0 : positionX - SCROLL_STEP;
		ref.current.scrollTo({ left: scrollToX, behavior: 'smooth' });
	};

	const onRightArrowClick = () => {
		if (!ref.current) {
			return;
		}
		const positionX: number = ref.current.scrollLeft;
		const maxOffset = ref.current.scrollWidth - ref.current.clientWidth;
		const scrollToX =
			positionX + SCROLL_STEP > maxOffset ? maxOffset : positionX + SCROLL_STEP;
		ref.current.scrollTo({ left: scrollToX, behavior: 'smooth' });
	};

	const handleScroll = (e: UIEvent<HTMLDivElement>) => {
		const scrollLeft = (e.target as HTMLElement).scrollLeft;
		const clientWidth = (e.target as HTMLElement).clientWidth;
		const scrollWidth = (e.target as HTMLElement).scrollWidth;
		if (scrollWidth >= clientWidth) {
			if (scrollLeft < 50) {
				setScrollPosition('left');
			} else if (scrollWidth - 50 < scrollLeft + clientWidth) {
				setScrollPosition('right');
			} else {
				setScrollPosition('center');
			}
		}
	};

	const leftArrowVisible = overflow && scrollPosition !== 'left';
	const rightArrowVisible = overflow && scrollPosition !== 'right';

	return {
		handleScroll,
		ref,
		onLeftArrowClick,
		onRightArrowClick,
		leftArrowVisible,
		rightArrowVisible,
	};
};
